<template lang="pug">
div.icon-container
  v-row.ma-0
    v-icon(small :color="iconColor") {{ icon }}
    span.ml-2 {{label}}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {InvoicePaymentStatus} from "@/types/enums";
import i18n from "@/plugins/i18n";
import {TranslateResult} from "vue-i18n";

@Component({
  components: {}
})
export default class StatusFilter extends Vue {
  private iconColor: string = ''
  private icon: string = ''
  private label: TranslateResult = i18n.t('billingPage.fullyPayed')

  updateIcon (value: string): void {
    if (value === InvoicePaymentStatus.notPaid) {
      this.icon = 'far fa-exclamation-circle'
      this.label = this.$i18n.t('billingPage.notPayed')
    } else if (value === InvoicePaymentStatus.fullyPaid) {
      this.icon = 'far fa-check-circle'
      this.label = this.$i18n.t('billingPage.fullyPayed')
    } else if (value === InvoicePaymentStatus.partiallyPaid) {
      this.icon = 'far fa-exclamation-triangle'
      this.label = this.$i18n.t('billingPage.partiallyPayed')
    } else if (value === InvoicePaymentStatus.notPayedAfterExpiration) {
      this.icon = 'far fa-exclamation-triangle'
      this.label = this.$i18n.t('billingPage.notPayedAfterExpiration')
    }

    if (value === InvoicePaymentStatus.notPaid) {
      this.iconColor = 'orange'
    } else if (value === InvoicePaymentStatus.fullyPaid) {
      this.iconColor = 'green'
    } else if (value === InvoicePaymentStatus.partiallyPaid) {
      this.iconColor = 'orange'
    } else if (value === InvoicePaymentStatus.notPayedAfterExpiration) {
      this.iconColor = 'red'
    }
  }

  mounted() {
    //@ts-ignore
    this.updateIcon(this.params.value)
  }
}
</script>

<style lang="stylus" scoped>
.icon-container
  text-align center
</style>